import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const Step3Root = styled('div', {
  paddingBottom: '$10',
  px: '$3',

  '& label': {
    display: 'block',
  },

  '@bp2': {
    px: '120px',
  },
})

export const Raw = styled(Stack, {
  maxWidth: '290px',

  '& span:nth-child(2)': {
    maxWidth: '190px',
    textAlign: 'left',
    color: '$accent-black',
    fontSize: '$body',

    '@bp2': {
      maxWidth: '240px',
    },
  },
})

export const MealPlanSubscription = styled(Stack, {
  width: '100%',
  backgroundColor: '$accent-white',
  padding: '$4 0',

  '@bp2': {
    padding: '0',
    paddingBottom: '$2',
  },
})

export const TitleContainer = styled(Stack, {
  '& span': {
    textAlign: 'center',
  },
})

export const EmailContainer = styled(Stack, {
  width: '100%',
  '& label': {
    fontWeight: '$regular',
    fontSize: '$small',
    lineHeight: '$small',
  },
})

export const CTAContainer = styled(Stack, {
  '& a': {
    textDecoration: 'underline',
    color: '$accent-black',
    '&:hover': {
      color: '$primary-500',
    },
    '&:active': {
      color: '$primary-700',
    },

    '@bp1': {
      textDecoration: 'none',
    },
  },
})

export const BenefitsBox = styled(Stack, {
  borderRadius: '$pill',
  border: '1px solid $accent-gray',
  background: '#FFF',
  cursor: 'pointer',
  width: '100%',
  padding: '20px 24px',
  display: 'flex',
  userSelect: 'none',
  '@bp2': {
    flexFlow: 'column-reverse',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '8px',
  },
})

export const BenefitsBoxPlusIcon = styled(Stack, {
  marginRight: 0,
})

export const RemoveButtonWrapper = styled('div', {
  display: 'flex',
  width: '12px',
  padding: '20px',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  touchAction: 'none',
  cursor: 'var(--cursor, pointer)',
  borderRadius: '5px',
  border: 'none',
  outline: 'none',
  appearance: 'none',
  backgroundColor: 'transparent',
  position: 'absolute',
  right: '0',
  ['-webkit-tap-highlight-color']: 'transparent',
  ['&:focus-visible']: {
    boxShadow: '0 0px 0px 2px #4c9ffe',
  },
  ['& svg']: {
    flex: '0 0 auto',
    margin: 'auto',
    height: '100%',
    overflow: 'visible',
    fill: '#919eab',
  },
})

export const PrimaryGoal = styled('span', {
  fontSize: '12px',
  color: 'red',
  marginLeft: '8px',
  '@bp2': {
    fontSize: '14px',
  },
})

export const TermsAndConditionsWrapper = styled('div', {
  cursor: 'pointer',
  userSelect: 'none',
  fontSize: '$small',
  color: '$accent-black',
})
